import { GtmServiceBase } from '@care/google-tag-manager';

class GtmServiceExtended extends GtmServiceBase {}
// GtmService instantiated with no clientLogger as it not available on this mfe
// Logging won't work
export const GtmService = new GtmServiceExtended({});

export { GtmEvent } from '@care/google-tag-manager';
